import styled from 'styled-components'

import { FLAG_COLOURS, NEUTRAL_COLOURS } from 'constants/colors'

export const StyledItemContainer = styled.div`
  background-color: ${NEUTRAL_COLOURS.GRAY_QUATERNARY};
  border-radius: 15px;
  display: flex;
  min-height: 60px;
  overflow: hidden;
`

export const StyledSessionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  
  & ${StyledItemContainer} ~ ${StyledItemContainer} {
    margin-top: 10px;
  }
`

export const StyledDayContainer = styled.div`
  align-items: center;
  background-color: ${NEUTRAL_COLOURS.GRAY_TERTIARY};
  display: flex;
  font-size: 16px;
  font-weight: 600;
  justify-content: center;
  min-width: 80px;
`

interface StyledPlanItemContainerProps {
  $highlighted?: boolean
}

export const StyledPlanItemContainer = styled.div<StyledPlanItemContainerProps>`
  display: flex;
  min-width: 100px;

  ${({ $highlighted }) => $highlighted && `
    color: ${FLAG_COLOURS.INFO};
  `}
`

export const StyledPlanGroupContainer = styled.div`
  display: flex;

  & ${StyledPlanItemContainer} ~ ${StyledPlanItemContainer} {
    margin-left: 20px;
  }
`

export const StyledPlanContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 10px;
`

export const StyledSessionContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  padding: 10px 15px;
  
  & ${StyledPlanContainer} ~ ${StyledPlanContainer} {
    border-top: 1px dashed ${NEUTRAL_COLOURS.GRAY_SECONDARY};
    margin-top: 7px;
    padding-top: 7px;
  }
`
